import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import ChangeBirthdayModal from './components/ChangeBirthdayModal';
import BirthdayPrivacySwitch from './components/BirthdayPrivacySwitch';

// SettingsPage is a lazy chunk, so it is extended by module path.
export default function addSettings() {
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    const user = this.user;
    if (!user.canEditBirthday()) return;
    items.add('changeBirthday', m(Button, {
      className: "Button",
      onclick: () => app.modal.show(ChangeBirthdayModal, {
        user
      })
    }, user.birthday() ? app.translator.trans('datlechin-birthdays.forum.settings.change_birthday_button') : app.translator.trans('datlechin-birthdays.forum.settings.add_birthday_button')), 80);
  });
  extend('flarum/forum/components/SettingsPage', 'privacyItems', function (items) {
    const user = this.user;
    if (!user.canEditBirthday() || !user.birthday()) return;
    items.add('showBirthday', m(BirthdayPrivacySwitch, {
      user: user,
      attribute: "showBirthday"
    }, app.translator.trans('datlechin-birthdays.forum.settings.show_birthday_label')), 90);
    items.add('showAge', m(BirthdayPrivacySwitch, {
      user: user,
      attribute: "showAge"
    }, app.translator.trans('datlechin-birthdays.forum.settings.show_age_label')), 80);
  });
}